import { fetchFromOldApi } from '~/services/Http';

import { IFormInput } from '../useOtherContact';

export type EmpOtherContactType = {
  fEmpCity: string;
  fEmpCountry: string;
  fEmpEmailOther: string;
  fEmpPhoneOther: string;
  fEmpPostalCode: string;
  fEmpState: string;
  fEmpStreetAddress1: string;
  fEmpStreetAddress2: string;
};

export type EmpOtherContact = {
  fEmpCity: string;
  fEmpCountry: string;
  fEmpEmailHome: string;
  fEmpPhoneHome: string;
  fEmpPostalCode: string;
  fEmpState: string;
  fEmpStreetAddress1: string;
  fEmpStreetAddress2: string;
};

export type Country = {
  code: string;
  name: string;
  description?: string;
};

export const putEmpOtherContactData = async (
  json: IFormInput,
  iEmpId: number,
) => {
  return await fetchFromOldApi('/form/employee/' + iEmpId + '/other', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(json),
  }).then((r) => r.json());
};

export const deleteEmpOtherContactData = async (iEmpId: number) => {
  return await fetchFromOldApi('/json/employee/' + iEmpId + '/other', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  }).then((r) => r.json());
};
